import { useQuery } from '@tanstack/react-query';
import axiosInstance from './axios';
import { DashboardReportResponseT } from '../types/dashboardTypes';

// POST: Get Top Selling Products
export const useGetTopSellingProducts = (postData: {
  pageNumber: number;
  pageSize: number;
  limit: number;
}) => {
  return useQuery({
    queryKey: ['useGetTopSellingProducts', postData],
    queryFn: async () => {
      const { data } = await axiosInstance.post(
        '/reports/getTopSellingProducts',
        postData
      );
      return data as DashboardReportResponseT & { hasNextPage?: boolean };
    },
    enabled:
      typeof postData.pageNumber === 'number' &&
      typeof postData.pageSize === 'number' &&
      typeof postData.limit === 'number',
  });
};

export const useGetStatistics = (postData: {
  startDate: string;
  endDate: string;
  interval: string;
}) => {
  return useQuery({
    queryKey: ['useGetStatistics', postData],
    queryFn: async () => {
      const { data } = await axiosInstance.post(
        '/reports/getStatistics',
        postData
      );
      return data;
    },
    enabled: !!postData.startDate && !!postData.endDate && !!postData.interval,
  });
};
